import { lazy, Suspense } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Contacts from "./Pages/ContactPage/Contacts";
import Loading from "./Components/Loading/Loading";
const Project = lazy(() => import("./Pages/ProjectPage/Project"));
const Home = lazy(() => import("../src/Pages/HomePage/Home"));
const About = lazy(() => import("./Pages/AboutUs/About"));
const Gallery = lazy(() => import("./Pages/Gallery/Gallery"));

function App() {
  return (
    <Suspense fallback={<Loading/>}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Project />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contactus" element={<Contacts />} />
        <Route path="*" element={<h1>404</h1>} />
      </Routes>
    </Suspense>
  );
}

export default App;
